import axios from "axios";
import router from "@/router";

const client = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

// request interceptor.
client.interceptors.request.use((request) => {
    const token = localStorage.getItem("token");

    // const locale = Vue.i18n.locale();

    if (token) {
        request.headers["Authorization"] = `Bearer ${token}`;
    }

    // if (locale) {
    // request.headers.common['Accept-Language'] = 'en';
    // }
    return request;
});

// response interceptor
client.interceptors.response.use(
    (response) => response,
    (error) => {
        const { status } = error.response;
        if (status >= 500) {
            console.log("client", error.response.data.message);
        }

        // unauthorized
        if (status == 401) {
            router.push({ name: "LandingPage" });
        }

        // has no permission
        if (status == 403) {
            router.push({ name: "home" });
        }

        return Promise.reject(error);
    }
);

export default client;